<h1 mat-dialog-title class="flex items-center space-x-2">
  <mat-icon [ngClass]="data?.iconClass">{{ data?.icon }}</mat-icon>
  <span>{{ data?.title }}</span>
</h1>

<div mat-dialog-content>
  @if (data?.html) {
    <h5 class="text-lg font-semibold mb-2">
      {{ data?.message }}
    </h5>
  }
  @if (data?.html) {
    <div [innerHTML]="data?.html"></div>
  }

  @if (!data?.html) {
    <span>{{ data?.message }}</span>
  }
</div>

<div mat-dialog-actions class="flex justify-end space-x-2">
  @if (data?.cancelButtonText) {
    <button mat-button class="uppercase {{ data?.cancelButtonClass || 'bg-primary text-white px-4 py-2 rounded' }}"
      (click)="onClose(false)">
      {{ data?.cancelButtonText }}
    </button>
  }

  @if (data?.approveButtonText) {
    <button mat-button class="uppercase {{ data?.approveButtonClass || 'bg-primary text-white px-4 py-2 rounded' }}"
      (click)="onClose(true)" cdkFocusInitial>
      {{ data?.approveButtonText }}
    </button>
  }
</div>